import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionTierService } from "./tx-tier-service";

export const transactionTierApi = createApi({
  reducerPath: "transactionApi",
  baseQuery: createBaseQuery(""),
  tagTypes: ["TransactionTier", "TransactionTierScale"],
  endpoints: (build) => ({
    listTransactionTiers: build.query<
      TransactionTier[],
      BaseTransactionParams & { search?: string }
    >({
      query: (params) => ({
        url: TransactionTierService.getEndpointUrl(params),
        method: "GET",
        params: { search: params.search },
      }),
      providesTags: ["TransactionTier"],
    }),

    getTransactionTier: build.query<
      TransactionTier,
      BaseTransactionParams & { tierId: string }
    >({
      query: (params) => ({
        url: TransactionTierService.getEndpointUrl(params, `/${params.tierId}`),
        method: "GET",
      }),
      providesTags: ["TransactionTier"],
    }),

    createTransactionTier: build.mutation<
      TransactionTier,
      BaseTransactionParams & { data: TransactionTierData }
    >({
      query: ({ data, ...params }) => ({
        url: TransactionTierService.getEndpointUrl(params),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TransactionTier"],
    }),

    deleteTransactionTier: build.mutation<
      void,
      BaseTransactionParams & { tierId: string }
    >({
      query: (params) => ({
        url: TransactionTierService.getEndpointUrl(params, `/${params.tierId}`),
        method: "DELETE",
      }),
      invalidatesTags: ["TransactionTier"],
    }),

    editTransactionTier: build.mutation<
      TransactionTier,
      BaseTransactionParams & { tierId: string; data: TransactionTierData }
    >({
      query: ({ data, ...params }) => ({
        url: TransactionTierService.getEndpointUrl(params, `/${params.tierId}`),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["TransactionTier"],
    }),

    listTransactionTierScales: build.query<
      TransactionTierScale[],
      BaseTransactionParams & { tierId: string }
    >({
      query: (params) => ({
        url: TransactionTierService.getEndpointUrl(
          params,
          `/${params.tierId}/scale`
        ),
        method: "GET",
      }),
      providesTags: ["TransactionTierScale"],
    }),

    createTransactionTierScale: build.mutation<
      TransactionTierScale,
      BaseTransactionParams & { data: TransactionTierScaleData }
    >({
      query: ({ data, ...params }) => ({
        url: TransactionTierService.getEndpointUrl(params, `/scale`),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TransactionTierScale"],
    }),

    editTransactionTierScale: build.mutation<
      TransactionTierScale,
      BaseTransactionParams & {
        scaleId: string;
        data: TransactionTierScaleData;
      }
    >({
      query: ({ data, ...params }) => ({
        url: TransactionTierService.getEndpointUrl(
          params,
          `/scale/${params.scaleId}`
        ),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["TransactionTierScale"],
    }),

    deleteTransactionTierScale: build.mutation<
      void,
      BaseTransactionParams & { scaleId: string }
    >({
      query: (params) => ({
        url: TransactionTierService.getEndpointUrl(
          params,
          `/scale/${params.scaleId}`
        ),
        method: "DELETE",
      }),
      invalidatesTags: ["TransactionTierScale"],
    }),
  }),
});
